export function openCookiePreferences() {
  window.Osano?.cm.showDrawer("osano-cm-dom-info-dialog-open");
}

export function openDoNotSellModal() {
  window.Osano?.cm.showDoNotSell();
}
